<app-section-title [title]="contentService.content().mainPage.myWork.title"
    (click)="triggerScroll('myWork')"></app-section-title>

<app-mobile-section-title [text]="contentService.content().mainPage.myWork.title"></app-mobile-section-title>

@for (project of contentService.content().mainPage.myWork.projects; track project.key; let i = $index) {
<app-project-box [project]="project" [index]="i">
</app-project-box>
}

<div id="ongoing-projects">
    <div id="text-of-ongoing-projects">
        <span id="headline">
            <span id="headline-number">{{ contentService.content().mainPage.myWork.projects.length + 1}}</span>
            <span id="headline-text">{{contentService.content().mainPage.myWork.ongoingProjects.headline}}</span>
        </span>
        <span id="text"> {{ contentService.content().mainPage.myWork.ongoingProjects.text }}</span>
    </div>
    <app-btn-to-contact [text]="contentService.content().mainPage.myWork.ongoingProjects.btn"></app-btn-to-contact>
</div>